import React from "react";

interface Props {
  onApprove: () => void;
  onReject: () => void;
  disabled?: boolean;
}

const ApproveRejectButtons: React.FC<Props> = ({ onApprove, onReject, disabled }) => (
  <div className="flex gap-1">
    <button
      type="button"
      onClick={onApprove}
      disabled={disabled}
      className="px-2 py-1 text-xs text-ds-status-success-text hover:bg-ds-status-success-light rounded disabled:opacity-50 transition-colors"
    >
      Approve
    </button>
    <button
      type="button"
      onClick={onReject}
      disabled={disabled}
      className="px-2 py-1 text-xs text-ds-status-error-text hover:bg-ds-status-error-light rounded disabled:opacity-50 transition-colors"
    >
      Reject
    </button>
  </div>
);

export default ApproveRejectButtons;
